import React, { Component } from "react";
import PrintComponents from "react-print-components";
import IconButton from "@material-ui/core/IconButton";
import DefaultButton from "../../../Buttons/DefaultButton/DefaultButton";
import DialogComponent from "../../../HelperComponents/DialogComponent/DialogComponent";
import PrintIcon from "../../../../assets/image/print.png";
import CloseDialogIcon from "../../../../assets/image/Mask.png";
import AcceptProductSticker from "./AcceptProductSticker";
import StickerQuantityDistribution, {
  expandRowsToStickers,
} from "./StickerQuantityDistribution";

class AcceptProductStickerPrintButton extends Component {
  state = {
    open: false,
    rows: [],
  };

  printTriggerRef = React.createRef();

  handleOpen = () => {
    this.setState({ open: true, rows: [] });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleQuantityChange = (rows) => {
    this.setState({ rows });
  };

  handlePrint = () => {
    if (!this.printTriggerRef.current) return;
    this.printTriggerRef.current.click();
    this.handleClose();
  };

  renderPrintBlock() {
    const { product } = this.props;
    const stickers = expandRowsToStickers(this.state.rows);
    if (stickers.length === 0) return null;

    return (
      <div className="accept_product_dialog__print">
        <PrintComponents
          trigger={
            <button
              ref={this.printTriggerRef}
              type="button"
              aria-hidden="true"
              tabIndex={-1}
            />
          }
        >
          <>
            {stickers.map((sticker) => (
              <AcceptProductSticker
                key={sticker.id}
                product={product}
                amount={sticker.amount}
                acceptanceDate={product.acceptance_date}
              />
            ))}
          </>
        </PrintComponents>
      </div>
    );
  }

  render() {
    const { product } = this.props;
    const { open, rows } = this.state;
    const distributedTotal = rows.reduce(
      (sum, row) => sum + row.perUnit * row.unitsCount,
      0
    );
    const printDisabled = distributedTotal !== product.amount;

    return (
      <>
        <button
          type="button"
          className="accept_product_sticker_print_button"
          onClick={this.handleOpen}
          title="Повторно напечатать стикер"
          aria-label="Повторно напечатать стикер"
        >
          <img src={PrintIcon} alt="" aria-hidden="true" />
        </button>

        <DialogComponent open={open} onClose={this.handleClose}>
          {open && (
            <div className="accept_product_dialog">
              <div className="title-dialog">Печать стикеров</div>
              <StickerQuantityDistribution
                availableTotal={product.amount}
                onChange={this.handleQuantityChange}
              />

              <div className="btn-wrapper order-dialog-btn">
                <DefaultButton
                  variant="outlined"
                  classes="cancel_btn"
                  onClick={this.handleClose}
                >
                  Отмена
                </DefaultButton>
                <DefaultButton
                  onClick={this.handlePrint}
                  disabled={printDisabled}
                >
                  Печать
                </DefaultButton>
              </div>

              <IconButton
                classes={{ root: "dialog_close_button" }}
                onClick={this.handleClose}
              >
                <img src={CloseDialogIcon} alt="close icon" />
              </IconButton>
            </div>
          )}
        </DialogComponent>

        {this.renderPrintBlock()}
      </>
    );
  }
}

export default AcceptProductStickerPrintButton;
